import ImageFile from "./ImageFile";

/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:01/05/2022
 @Time:14:16
 **/

export default class LogoFile extends ImageFile {



    static createFromJson(logoJsonFile,file)
    {
        file=new LogoFile();
        super.createFromJson(logoJsonFile,file);
        return file;
    }


    getFileURLFileType() {
        return "SOCIETE_LOGO";
    }
}